import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Select as MuiSelect } from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';

export default function Select(props) {
  const {
    name,
    label,
    value,
    error = null,
    disabled,
    onChange,
    options,
    readOnly,
    isColor,
    vatStatus,
    size,
    sx
  } = props;

  const getColor = () => {
    if (vatStatus) {
      if (value === "CZYNNY") return "green";
      if (value === "NIEZAREJESTROWANY" || value === "ZWOLNIONY") return "red";
      return "";
    }

    if (isColor === true) {
      return value === false ? "red" : "green";
    }

    return "";
  };

  return (
    <Box sx={{ marginTop: size === 'small' ? 0 : 1, marginBottom: size === 'small' ? 0 : 0.4 }}>
      <FormControl
        variant="outlined"
        fullWidth
        size={size}
        sx={sx}
        {...(error && { error: true })}
      >
        <InputLabel>{label}</InputLabel>
        <MuiSelect
          inputProps={{
            readOnly: readOnly,
          }}
          label={label}
          style={{ color: getColor() }}
          name={name}
          value={value}
          disabled={disabled}
          onChange={onChange}
          sx={size === 'small' ? { '& .MuiSelect-select': { py: 1 } } : undefined}
        >
          {Array.isArray(options) ? (
            options.map((item) => {
              if (item && item.key !== undefined && item.value !== undefined) {
                return (
                  <MenuItem key={item.key} value={item.key}>
                    {item.value}
                  </MenuItem>
                );
              } else if (item && item.id !== undefined && item.title !== undefined) {
                return (
                  <MenuItem key={item.id} value={item.id}>
                    {item.title}
                  </MenuItem>
                );
              } else {
                console.error("Invalid option item:", item);
                return null;
              }
            })
          ) : (
            console.error("Options is not an array:", options)
          )}
        </MuiSelect>
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </Box>
  );
}
